module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-next-seo/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"ds-site-aa-local-pages","short_name":"AA Local Pages","start_url":"/instructor","background_color":"#FFCC00","theme_color":"#FFCC00","display":"minimal-ui","icon":"src/assets/favicons/favicon-32x32.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"1a6c40e4faf9001fd472b44e5ec211f4"},
    },{
      plugin: require('../node_modules/gatsby-plugin-sentry/gatsby-browser.js'),
      options: {"plugins":[],"dsn":"https://dfc1f3987ceb427e951d91d3bc853a79@o284266.ingest.sentry.io/5395588","environment":"production","release":"ds-site-aa-local-pages@99-RC.10","enabled":true},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
